import Jasmia101 from '../../../media/SCG/Jasmia/10/Jasmia 10.webp'
import Jasmia102 from '../../../media/SCG/Jasmia/10/Jasmia 10 D.webp'
import Jasmia103 from '../../../media/SCG/Jasmia/10/Jasmia 10 P.webp'
import Jasmia104 from '../../../media/SCG/Jasmia/10/Jasmia 10 Attic.png'

const Jasmia10images =[
Jasmia101,Jasmia102,Jasmia103,Jasmia104
]

export default Jasmia10images;